/* Weggilees Theme — global JS */

/* ── Cart drawer ──────────────────────────────────────────────────────────── */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('[data-cart-drawer]');
    this.overlay = this.querySelector('[data-cart-overlay]');
  }

  open() {
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    this.drawer?.focus();
  }

  close() {
    this.removeAttribute('open');
    document.body.style.overflow = '';
  }

  connectedCallback() {
    this.overlay?.addEventListener('click', () => this.close());
    this.querySelectorAll('[data-cart-close]').forEach(el =>
      el.addEventListener('click', () => this.close())
    );
  }
}
customElements.define('cart-drawer', CartDrawer);

/* ── Cart toggle ──────────────────────────────────────────────────────────── */
document.addEventListener('click', e => {
  if (e.target.closest('[data-open-cart]')) {
    document.querySelector('cart-drawer')?.open();
  }
});

/* ── Add to cart (AJAX) ───────────────────────────────────────────────────── */
document.addEventListener('submit', async e => {
  const form = e.target.closest('[data-atc-form]');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('[data-atc-btn]');
  const originalText = btn.textContent;

  btn.disabled = true;
  btn.textContent = 'ADDING...';

  try {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });

    if (!res.ok) throw new Error('Cart add failed');

    await refreshCartCount();
    document.querySelector('cart-drawer')?.open();
    btn.textContent = 'ADDED!';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1800);
  } catch {
    btn.textContent = 'TRY AGAIN';
    btn.disabled = false;
  }
});

async function refreshCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    await refreshCartDrawer();
  } catch {}
}

async function refreshCartDrawer() {
  try {
    const res = await fetch('/?section_id=cart-drawer');
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-items]');
    const current = document.querySelector('[data-cart-items]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  } catch {}
}

/* ── Quantity stepper ─────────────────────────────────────────────────────── */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-qty-change]');
  if (!btn) return;

  const line = btn.dataset.line;
  const delta = parseInt(btn.dataset.qtyChange, 10);
  const display = btn.closest('[data-line-item]')?.querySelector('[data-qty-display]');
  if (!display) return;

  const current = parseInt(display.textContent, 10);
  const next = Math.max(0, current + delta);

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: next }),
    });
    if (!res.ok) throw new Error();
    await refreshCartCount();
  } catch {}
});

/* ── Wriggle idle animation on mascot elements ────────────────────────────── */
document.querySelectorAll('[data-wriggle]').forEach(el => {
  el.style.animation = 'wg-wriggle 1.5s ease-in-out infinite';
});

/* ── Page load: initialise cart count ────────────────────────────────────── */
refreshCartCount();
